// Výběr priority v UI: zaškrtávátko „Kritická závada“ (výchozí nezaškrtnuto = běžná).
// Zaškrtávátko se zákazníkovi nezobrazí, má-li jen jednu prioritu nebo nemá žádné lhůty (SLA).

export function urciPrioritu(priority, pravidla, zakaznikId) {
  const kriticka = priority.find(p => p.kod === 'kriticka') || null;
  const bezna = priority.find(p => p.kod === 'bezna')
    || priority.filter(p => p.kod !== 'kriticka').sort((a, b) => a.poradi - b.poradi)[0] || null;
  const maLhuty = zakaznikId
    ? pravidla.some(r => String(r.zakaznik_id) === String(zakaznikId) && (r.reakce_h !== null || r.vyreseni_h !== null))
    : false;
  const vice = priority.length > 1 && kriticka && bezna && kriticka.id !== bezna.id;
  return { kriticka, bezna, zobrazit: !!(vice && maLhuty) };
}
